exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".MiniListItem-2757d60f{display:block;margin-bottom:15px}.MiniListItem-2757d60f .title-4774158a{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin-bottom:1px}.MiniListItem-2757d60f .flex-6a8c1372{display:flex}.MiniListItem-2757d60f .left-9224e182{margin-right:10px}.MiniListItem-2757d60f .right-5aec058a{flex:1;min-width:0}a.MiniListItem-2757d60f,a.MiniListItem-2757d60f:hover,a.MiniListItem-2757d60f:focus,a.MiniListItem-2757d60f:active,a.MiniListItem-2757d60f:visited{color:inherit;text-decoration:none}.MiniListItemDetail-dd43306d{font-size:13px;line-height:16px;color:#757575;margin-bottom:4px}.CardSectionHeading-87b8a7e9{padding-bottom:9px;margin-bottom:24px;border-bottom:1px solid #E0E0E0}\n", ""]);

// Exports
exports.locals = {
	"MiniListItem": "MiniListItem-2757d60f",
	"title": "title-4774158a",
	"flex": "flex-6a8c1372",
	"left": "left-9224e182",
	"right": "right-5aec058a",
	"MiniListItemDetail": "MiniListItemDetail-dd43306d",
	"CardSectionHeading": "CardSectionHeading-87b8a7e9"
};